import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getStripeDocumentUrl } from '../../../api/Deals/identification/sendStripeVerification.api';
import styles from './StripeSection.module.scss';
import clsx from 'clsx';
import {
	Visibility,
	CheckCircle,
	Announcement,
	DomainVerification,
} from '@mui/icons-material';
import { Grid, Button } from '@material-ui/core';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { humanizer } from '../../../utils/snakeCaseToHumanize';
const StripeSection = ({ selected, hide, openVerificationModal }) => {
	const [identification, setIdentification] = useState();
	const [stripeDocImgUrl, setStripeDocImgUrl] = useState();
	const [stripeSelfieImgUrl, setStripeSelfieImgUrl] = useState();

	useEffect(() => {
		let identification = selected?.identification;
		setIdentification(identification);
	}, [selected]);

	useEffect(() => {
		setStripeDocImgUrl();
		setStripeSelfieImgUrl();
	}, [hide]);

	const handleStripeFileUrl = async (selected, param) => {
		if (stripeDocImgUrl) {
			setStripeDocImgUrl();
		} else {
			if (
				selected?.identification?.verification?.status ===
				'manually_verified'
			) {
				let imgUrl = selected?.identification?.report?.document?.imgUrl;
				setStripeDocImgUrl(imgUrl);
			} else if (param === 'document') {
				let files = identification?.report?.document?.files;
				files &&
					getStripeDocumentUrl(files[0], (returned) => {
						returned?.data?.url &&
							setStripeDocImgUrl(returned.data.url);
					});
			} else if (param === 'selfie') {
				let file = identification?.report?.selfie?.selfie;
				getStripeDocumentUrl(file, (returned) => {
					returned?.data?.url &&
						setStripeSelfieImgUrl(returned.data.url);
				});
			}
		}
	};
	if (
		identification?.verification?.status === 'verified' ||
		identification?.verification?.status === 'manually_verified'
	)
		return (
			<div className={hide ? styles.hide : null}>
				<div className={styles.row}>
					<div className={styles.rowHeaderWrapper}>
						<DomainVerification />
						<span>Document Information</span>
					</div>
					<hr />
					<Grid
						container
						className={clsx(
							styles.rowContentWrapper,
							styles.marginY
						)}
					>
						<Grid
							className={styles.marginY}
							item
							xs={12}
							sm={6}
							md={3}
						>
							<div>
								<span className={styles.title}>Full Name</span>
							</div>
							<p>
								{identification?.report?.document?.first_name}
								&nbsp;
								{identification?.report?.document?.last_name}
							</p>
						</Grid>
						<Grid
							className={styles.marginY}
							item
							xs={12}
							sm={6}
							md={3}
						>
							<div>
								<span className={styles.title}>Address</span>
							</div>
							{identification?.verification?.status ===
							'manually_verified' ? (
								<p>
									{identification?.report?.document?.address1}
									&nbsp;
									{identification?.report?.document?.address2}
									&nbsp;
									{identification?.report?.document?.city}
									&nbsp;
									{identification?.report?.document?.province}
									&nbsp;
									{
										identification?.report?.document
											?.postalCode
									}
									&nbsp;
								</p>
							) : (
								<p>
									{
										identification?.report?.document
											?.address?.line1
									}
									&nbsp;
									{
										identification?.report?.document
											?.address?.city
									}
									&nbsp;
									{
										identification?.report?.document
											?.address?.state
									}
									&nbsp;
									{
										identification?.report?.document
											?.address?.country
									}
									&nbsp;
									{
										identification?.report?.document
											?.address?.postal_code
									}
								</p>
							)}
						</Grid>
						<Grid
							className={styles.marginY}
							item
							xs={12}
							sm={6}
							md={3}
						>
							<div className={styles.documentTypeWrapper}>
								<span className={styles.title}>
									Document Type
								</span>
								<CheckCircle className={styles.chkIcon} />
								<Visibility
									className={styles.urlcon}
									onClick={() =>
										handleStripeFileUrl(
											selected,
											'document'
										)
									}
								/>
							</div>
							<p>
								{identification?.report?.document?.type
									? humanizer(
											identification?.report?.document
												?.type
									  )
									: '---'}
							</p>

							<p>
								<span className={styles.title}>
									Issued date
								</span>
								<span>
									&nbsp;&nbsp;
									{
										identification?.report?.document
											?.issued_date?.day
									}
									-
									{
										identification?.report?.document
											?.issued_date?.month
									}
									-
									{
										identification?.report?.document
											?.issued_date?.year
									}
								</span>
							</p>

							<p>
								<span
									className={styles.verifiationText_success}
								>
									Verified&nbsp;&nbsp;
								</span>
								<span>
									{identification?.verification?.date}
								</span>
							</p>

							{stripeDocImgUrl && (
								<img
									src={stripeDocImgUrl}
									alt='User Verification'
									height='auto'
									width='85%'
								/>
							)}
						</Grid>
						<Grid
							className={styles.marginY}
							item
							xs={12}
							sm={6}
							md={3}
						>
							{identification?.verification?.status ===
							'manually_verified' ? (
								<>
									<div>
										<span className={styles.title}>
											Selfie
										</span>
									</div>
									<div>
										<p className={styles.stripeProcessing}>
											(User manually verified)
										</p>
										<Button
											className={
												styles.btn_secureVerification
											}
											variant='outlined'
											startIcon={<LockOpenIcon />}
											onClick={openVerificationModal}
										>
											Secure Verification
										</Button>
									</div>
								</>
							) : (
								<>
									<div>
										<span className={styles.title}>
											Selfie
										</span>
										{identification?.report?.selfie
											?.status === 'verified' && (
											<>
												<CheckCircle
													className={styles.chkIcon}
												/>
												<Visibility
													className={styles.urlcon}
													onClick={() =>
														handleStripeFileUrl(
															selected,
															'selfie'
														)
													}
												/>
												<p
													className={clsx(
														styles.stripeVerified,
														styles.selfieTitle
													)}
												>
													Verified
												</p>
											</>
										)}
										{identification?.report?.selfie
											?.status === 'unverified' && (
											<>
												<Announcement
													className={
														styles.warningIcon
													}
												/>
											</>
										)}
									</div>

									{stripeSelfieImgUrl && (
										<img
											src={stripeSelfieImgUrl}
											alt='User Verification'
											height='auto'
											width='85%'
										/>
									)}
								</>
							)}
						</Grid>
					</Grid>
				</div>
			</div>
		);
	else return <></>;
};

const mapStateToProps = (state) => ({
	leads: state.leads.leads,
});

export default connect(mapStateToProps)(StripeSection);
